/**
 * Created by Shaun on 18/03/2017.
 */

export default function (routesContext) {
  let routes = {};

  routesContext.keys().forEach((route) => {
    let routePath = route
      .split('/')
      .filter(file => file !== '.' && file !== 'page.js' && file !== 'page.vue')
      .map(file => file.replace('routes', 'children'));

    route = routesContext(route);

    let name = _.last(routePath);
    let namePath = routePath.filter(part => part !== 'children').join('/');

    if (route.name) {
      name = route.name;
      namePath = route.name;
    }

    let propsAsPath = _.reduce(route.default.props, (propsAsPath, prop, propName) => {
      if (_.isObject(prop) && prop.required === true) {
        return propsAsPath + '/:' + propName; //add prop to path
      } else if (_.isObject(prop)) {
        return propsAsPath + '/:' + propName + '?'; //add prop to path but is optional
      } else {
        return propsAsPath + '/:' + prop; //add prop to array
      }
    }, '');

    if (route.default) {
      route.default.name = route.default.name || name.replace(/\//g, ' ');
    }

    _.set(routes, routePath.join('.'), {
      name: namePath,
      path: name + propsAsPath,
      redirect: route.redirect || null,
      component: route.default,
      meta: {
        pathWithProps: name + propsAsPath,
      },
      props: true
    });
  });

  let convertChildren = (route) => {
    if (route.children) {
      route.children = _.values(route.children).map(childRoute => {
        return convertChildren(childRoute)
      });
    }
    return route;
  };

  routes = _.values(routes).map(route => convertChildren(route)).map(route => {
    route.path = '/' + route.path;
    return route;
  });

  return routes;
}